var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"visibilidade-camada"}},[_c('el-checkbox',{on:{"change":_vm.onChange},model:{value:(_vm.selecionado),callback:function ($$v) {_vm.selecionado=$$v},expression:"selecionado"}},[_vm._v("Visibilidade da área plantada")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }